import getDeliveryTimeWorkDaysByShopCountryCode from "./attributes/getDeliveryTimeWorkDaysByShopCountryCode"

import { CommerceToolsDeliveryOption } from "@secureo/common/utils/commerceTools/graphql/queries/fetchDeliveryOptions"
import { DeliveryOption } from "@secureo/common/typings/Product"

const formatDeliveryOption = (commerceToolsDeliveryOption: CommerceToolsDeliveryOption) => {
	const {
		id,
		key: sku,
		masterData: {
			current: {
				name,
				description,
				masterVariant: { attributesRaw = [] },
			},
		},
	} = commerceToolsDeliveryOption

	const deliveryTimeWorkDaysAttribute = attributesRaw.find(
		({ name }) => name === "deliveryTimeWorkdays",
	)
	const deliveryTimeWorkDaysByShopCountryCode = getDeliveryTimeWorkDaysByShopCountryCode(
		deliveryTimeWorkDaysAttribute as any,
	)

	const formattedDeliveryOption: DeliveryOption = {
		id,
		sku,
		name,
		description,
		deliveryTimeWorkDaysByShopCountryCode,
	}

	return formattedDeliveryOption
}
export default formatDeliveryOption
